import { CheckboxIcon, ShieldExclamationIcon } from "@aureskonnect/react-ui";
import React from "react";
import { ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { toast } from "react-toastify";

import { store as userStore } from "@components/VerticalLayout/store";
import { store } from "../../../store/project";
import ModalAssociateStore from "./ModalAssociateStore";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import "@assets/swal.css";
import "@assets/theme.css";
import { publishProjectStatus, RedisPublishList } from "./hooks";
import {
    getNamesFromKeys,
    parsePaymentErrors,
    showWarningToast,
} from "@helpers/general";
import { errorTypes } from "@constants/index";
import { useFetchGlobal } from "../../../api/hooks";

type CardFooterModalPublishType = {
    rowData: any;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
    setIsModesModalPublishOpened: Function;
    setIsDataUpdated: Function;
    setMsg: Function;
    setIsModalErrorInfo: Function;
};

export default function CardFooterModalPublish({
    rowData,
    setIsModalLoadingOpened,
    setModalLoadingData,
    setIsModesModalPublishOpened,
    setIsDataUpdated,
    setMsg,
    setIsModalErrorInfo,
}: CardFooterModalPublishType) {
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isValidatedClicked, setIsValidatedClicked] = React.useState<boolean>(
        false
    );

    const { isModesModalPublishOpened } = useSnapshot(store);
    const {
        userID,
        franchiseID,
        oneShop,
        shopID,
        shopName,
        operatorID,
    } = useSnapshot(userStore);
    const uuidUser = localStorage.getItem("uuidUser");
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { projectData } = useSnapshot(store);
    const [isDisabled, setIsDisabled] = React.useState(false);
    const [
        isValidateButtonDisabled,
        setIsValidateButtonDisabled,
    ] = React.useState<boolean>(false);

    function AssociateProject() {
        let idShops: any = [];
        if (rowData !== undefined) {
            Object.values(rowData.shopKey) !== undefined &&
                Object.values(rowData.shopKey).forEach((el: any) => {
                    idShops.push(el);
                });
        }
        idShops = [...new Set(idShops), "0"];
        return idShops;
    }
    function isAssociate() {
        let projectId: any = [];
        let associateskeys: any = [];
        let isAssociateShops: boolean = false;
        if (projectData !== undefined) {
            projectData.forEach((el: any) => {
                Object.values(el?.subRows).forEach((elment: any) => {
                    if (rowData?.subRows !== undefined) {
                        Object.values(rowData?.subRows).forEach((item: any) => {
                            if (
                                elment?.id_boutique === item?.id_boutique &&
                                el?.Status === "Publié"
                            ) {
                                associateskeys.push(el?.id_boutique);
                                projectId.push(el?.id_project);
                            }
                        });
                    }
                });
            });
        }
        if (Object.keys(associateskeys).length > 0) {
            isAssociateShops = true;
        }
        return isAssociateShops;
    }

    let isAssociateShops: boolean = isAssociate();

    async function handleSaveButtonOnClickEvent() {
        setIsModalLoadingOpened(true);
        setModalLoadingData({
            title: "Publication in progress",
            message: "the publication of the template is in progress",
        });

        let data: any = {};
        data[shopID] = {
            designation: shopName,
            id_boutique: shopID,
            hoursOfUse:
                rowData.hoursOfUse !== undefined ? rowData.hoursOfUse : "",
        };
        let dataAssociate: any[] = await AssociateProject();
        let savedData = {
            userId: userID,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            shopId: oneShop ? [shopID, "0"] : dataAssociate,
            projectId: rowData.projectId,
            status: "Publié",
            modified_at: `${moment().format("DD/MM/YYYY [at] h:mm a")}`,
            designation: rowData[t("Designation")],
        };

        try {
            const result: any = await publishProjectStatus(
                savedData,
                fetchGlobal
            );
            setIsModalLoadingOpened(false);
            const errors = result?.error ?? false;

            let errorMap: any = {};
            if (result.canPublish !== true) {
                errorMap = parsePaymentErrors(result.canPublish);
            }

            const toastConfig: any = {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                newestOnTop: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                icon: (
                    <ShieldExclamationIcon
                        width={25}
                        height={25}
                        fill="white"
                    />
                ),
            };
            const hasActiveButMissingData =
                Array.isArray(result.canPublish) &&
                result.canPublish.some((parent: any) =>
                    Object.values(parent).some((child: any) =>
                        Object.values(child).some((payment: any) =>
                            Object.values(payment).includes(
                                "hasActiveButMissingData"
                            )
                        )
                    )
                );

            if (
                (result.canPublish !== true && hasActiveButMissingData) ||
                result.hasActiveMeansOfPayment === false
            ) {
                if (result.hasActiveMeansOfPayment === false) {
                    toast.error(
                        t(
                            "Please note, you cannot publish a template without an activated payment method"
                        ),
                        toastConfig
                    );
                }
                const targetErrorType = "hasActiveButMissingData";

                if (errorTypes.includes(targetErrorType)) {
                    const errorType = targetErrorType;
                    const keys = errorMap[errorType];

                    const { details } = getNamesFromKeys(keys);
                    const shopAppMap: Record<
                        string,
                        { apps: string[]; name: string }[]
                    > = {};

                    rowData.subRows.forEach((shop: any) => {
                        const shopName = shop.Désignation;

                        const appsWithNames = (shop.subRows || [])
                            .map((app: any) => {
                                const detail = details.find(
                                    (d) =>
                                        d.childId === app.appId &&
                                        d.parentId === shop.shopId
                                );
                                if (!detail) return null;
                                return {
                                    appName: app.Désignation,
                                    name: detail.name,
                                };
                            })
                            .filter(Boolean);

                        if (appsWithNames.length > 0) {
                            const byName = appsWithNames.reduce(
                                (acc: any, { appName, name }: any) => {
                                    if (!acc[name]) acc[name] = [];
                                    acc[name].push(appName);
                                    return acc;
                                },
                                {} as Record<string, string[]>
                            );

                            shopAppMap[shopName] = Object.entries(byName).map(
                                ([name, apps]: [name: any, apps: any]) => ({
                                    apps,
                                    name,
                                })
                            );
                        }
                    });

                    const formattedLines =
                        "\n" +
                        Object.entries(shopAppMap)
                            .flatMap(([shopName, groups]) =>
                                groups.map(
                                    ({ apps, name }) =>
                                        `• ${apps.join(
                                            ", "
                                        )} → ${shopName} (${name})`
                                )
                            )
                            .join("\n") +
                        "\n";

                    const messageMap: Record<ErrorType, string> = {
                        hasActiveButMissingData: `The following application(s) are missing associated payment configuration {{formattedLines}}`,
                    };
                    setMsg(
                        t(messageMap[errorType], {
                            formattedLines: formattedLines,
                        })
                    );
                    setIsModalErrorInfo(true);
                }
            } else if (result.message === 3) {
                toast.info(
                    `${t(
                        "Warning: This template is currently being edited by another user. Please try again later."
                    )!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
            } else if (!errors) {
                toast.success(
                    `${t("The project is published successfully")!}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );

                setIsDataUpdated(true);

                let ids: any = (!oneShop
                    ? [...rowData.subRows]
                    : [rowData]
                ).map((el: any) => el.shopId);
                RedisPublishList(ids, fetchGlobal);
            }

            if (result.canPublish !== true) {
                showWarningToast(result, toastConfig);
            }
        } catch (e: any) {
            setIsModalLoadingOpened(false);
            console.log(`${t("There's an error")}!`);
        }
    }
    async function handleSaveButtonOnClickEventDissociationShops() {
        setIsModalLoadingOpened(true);
        setModalLoadingData({
            title: "Publication in progress",
            message: "the publication of the template is in progress",
        });
        if (isValidateButtonDisabled === false) {
            setIsValidateButtonDisabled(true);

            let dataAssociate: any[] = AssociateProject();

            let savedData = {
                userId: userID,
                franchiseId: franchiseID,
                shopId: dataAssociate,
                projectId: rowData.projectId,
                operatorId: operatorID,
                uuidUser: uuidUser,
                status: "Publié",
                modified_at: `${moment().format("DD/MM/YYYY [at] h:mm a")}`,
                designation: rowData[t("Designation")],
            };

            try {
                const result: any = await publishProjectStatus(
                    savedData,
                    fetchGlobal
                );
                const hasError = result?.error ?? false;
                let errorMap: any = {};
                if (result.canPublish !== true) {
                    errorMap = parsePaymentErrors(result.canPublish);
                }

                const toastConfig: any = {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    newestOnTop: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: (
                        <ShieldExclamationIcon
                            width={25}
                            height={25}
                            fill="white"
                        />
                    ),
                };
                const hasActiveButMissingData =
                    Array.isArray(result.canPublish) &&
                    result.canPublish.some((parent: any) =>
                        Object.values(parent).some((child: any) =>
                            Object.values(child).some((payment: any) =>
                                Object.values(payment).includes(
                                    "hasActiveButMissingData"
                                )
                            )
                        )
                    );

                if (
                    (result.canPublish !== true && hasActiveButMissingData) ||
                    result.hasActiveMeansOfPayment === false
                ) {
                    if (result.hasActiveMeansOfPayment === false) {
                        toast.error(
                            t(
                                "Please note, you cannot publish a template without an activated payment method"
                            ),
                            toastConfig
                        );
                    }
                    const targetErrorType = "hasActiveButMissingData";

                    if (errorTypes.includes(targetErrorType)) {
                        const errorType = targetErrorType;
                        const keys = errorMap[errorType];

                        const { details } = getNamesFromKeys(keys);
                        const shopAppMap: Record<
                            string,
                            { apps: string[]; name: string }[]
                        > = {};

                        rowData.subRows.forEach((shop: any) => {
                            const shopName = shop.Désignation;

                            const appsWithNames = (shop.subRows || [])
                                .map((app: any) => {
                                    const detail = details.find(
                                        (d) =>
                                            d.childId === app.appId &&
                                            d.parentId === shop.shopId
                                    );
                                    if (!detail) return null;
                                    return {
                                        appName: app.Désignation,
                                        name: detail.name,
                                    };
                                })
                                .filter(Boolean);

                            if (appsWithNames.length > 0) {
                                const byName = appsWithNames.reduce(
                                    (acc: any, { appName, name }: any) => {
                                        if (!acc[name]) acc[name] = [];
                                        acc[name].push(appName);
                                        return acc;
                                    },
                                    {} as Record<string, string[]>
                                );

                                shopAppMap[shopName] = Object.entries(
                                    byName
                                ).map(
                                    ([name, apps]: [name: any, apps: any]) => ({
                                        apps,
                                        name,
                                    })
                                );
                            }
                        });

                        const formattedLines =
                            "\n" +
                            Object.entries(shopAppMap)
                                .flatMap(([shopName, groups]) =>
                                    groups.map(
                                        ({ apps, name }) =>
                                            `• ${apps.join(
                                                ", "
                                            )} → ${shopName} (${name})`
                                    )
                                )
                                .join("\n") +
                            "\n";

                        const messageMap: Record<ErrorType, string> = {
                            hasActiveButMissingData: `The following application(s) are missing associated payment configuration {{formattedLines}}`,
                        };
                        setMsg(
                            t(messageMap[errorType], {
                                formattedLines: formattedLines,
                            })
                        );
                        setIsModalErrorInfo(true);
                    }
                } else if (result.message === 3) {
                    toast.warn(
                        `${t(
                            "Warning: This template is currently being edited by another user. Please try again later."
                        )!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                } else if (!hasError) {
                    toast.success(
                        `${t("The project is published successfully")!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );

                    setIsValidateButtonDisabled(false);
                    setIsDataUpdated(true);
                    let ids: any = (!oneShop
                        ? [...rowData.subRows]
                        : [rowData]
                    ).map((el: any) => el.shopId);
                    RedisPublishList(ids, fetchGlobal);
                } else {
                    throw Error(hasError?.message);
                }
                if (result.canPublish !== true) {
                    showWarningToast(result, toastConfig);
                }
                setIsModalLoadingOpened(false);
                setIsModalOpened(false);
            } catch (e: any) {
                setIsModalLoadingOpened(false);

                setIsValidateButtonDisabled(false);
                console.log(`${t("There's an error")}!`, e);
            }
        }
    }

    React.useEffect(() => {
        if (isValidatedClicked) {
            handleSaveButtonOnClickEventDissociationShops();
        }
        // eslint-disable-next-line
    }, [isValidatedClicked]);

    return (
        <React.Fragment>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="primary"
                    onClick={() => {
                        setIsModesModalPublishOpened!(
                            !isModesModalPublishOpened
                        );
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    disabled={isDisabled}
                    onClick={() => {
                        if (!isAssociateShops || oneShop) {
                            setIsModesModalPublishOpened(false);
                            setIsDisabled(true);
                            handleSaveButtonOnClickEvent();
                        } else {
                            setIsModalOpened(true);
                        }
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
            {isModalOpened ? (
                <ModalAssociateStore
                    setIsModalOpened={setIsModalOpened}
                    isModalOpened={isModalOpened}
                    setIsValidatedClicked={setIsValidatedClicked}
                    rowData={rowData}
                />
            ) : null}
        </React.Fragment>
    );
}
